import React from "react";

export default class Seizures extends React.Component {
  render() {
    return (
      <>
        <h3>Symptoms:</h3>
        <p>
          Loss of conciousness, seizures with immidiete tension of all body
          muscles or stiffening of a body in the shape of an arc and remaining
          stiff, overturned eyeballs, foam out of mouth, loosening of
          constrictors.{" "}
        </p>
        <h3>What to do?</h3>
        <ul>
          <li>
            The only thing you need to do (after first removing any sharp and
            dangerous objects) is to kneel behind the head of the victim and lay
            down the head on your knees, at the same time holding it with your
            hands, to protect it from injury.
          </li>
          <li>
            Under no circumstence put anything in the victim's mouth, don't
            fight the seizurs, do not put your fingers into mouth.
          </li>
          <li>
            After the attack follows an after attack sleep - it's natural and in
            no case should that sleep be interrupted. A person woken up of that
            sleep can be aggressive, confuded, scared. After the attack lie the
            person down in the safe position (on a side), every 2 minutes check
            for breath and pulse.{" "}
          </li>
          <li>
            If the sleep lasts longer than 5 minutes, call a medical rescue
            team.
          </li>
          <li>
            If after the attack there is another one, and inbetween there is no
            regaining of conciousness - this is an epileptic state and you need
            to call an ambulance.
          </li>
          <li>
            If this is the first time the victim is experiencing a seizure, call
            a medical rescue team.
          </li>
        </ul>
      </>
    );
  }
}
